import type { ImgHTMLAttributes } from 'react';
import { useAuthenticatedBlobUrl } from '@/hooks/useAuthenticatedBlobUrl';

function needsAuthenticatedFetch(src: string) {
  return src.startsWith('/api/');
}

type AuthenticatedImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src?: string | null;
};

export function AuthenticatedImage({ src, alt = '', ...props }: AuthenticatedImageProps) {
  const protectedSrc = src && needsAuthenticatedFetch(src) ? src : undefined;
  const { blobUrl, loading } = useAuthenticatedBlobUrl(protectedSrc);

  if (!src) return null;
  if (!needsAuthenticatedFetch(src)) {
    return <img src={src} alt={alt} {...props} />;
  }
  if (loading || !blobUrl) {
    return <div aria-hidden className={props.className} />;
  }
  return <img src={blobUrl} alt={alt} {...props} />;
}
